export default __webpack_public_path__ + "static/media/03.d8e5bb8e.jpg";